import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import belongsTo from "cc-frontend/helpers/belongs-to"

export default class ClassWebsiteNav extends Component {
  @service("ember-store") store

  @belongsTo("args.classWebsite", "planbook") planbook
  @belongsTo("planbook", "rotationCalendar") rotationCalendar
}
